import { render } from "./SubmissionCard.vue?vue&type=template&id=d02d0e0e&ts=true"
import script from "./SubmissionCard.vue?vue&type=script&lang=ts"
export * from "./SubmissionCard.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__